import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
    RecentChatRoster,
    RecentChatUpdateAction,
    RecentChatUpdateNotification,
    RecentChatAction,
    resetRecentChat
} from "../../../Actions/RecentChatActions";
import { loaderSVG, Nochat, EmptySearch, IconEmptyArchive, StartVector, IconNoInternet } from "../../../assets/images";
import { isRenderMessageType, sortBydate } from "../../../Helpers/Chat/RecentChat";
import {
    NO_RECENT_CHAT_INFO,
    NO_RECENT_CLICK_ON_INFO,
    NO_RECENT_SEARCH_CONTACTS_INFO,
    NO_RESULTS_FOUND
} from "../../processENV";
import SDK from "../../SDK";
import Title from "../Common/BrowserTitle";
import RecentChat from "./RecentChat";
import RosterContacts from "./RosterContacts";
import RecentSearch from "./RecentSearch";
import GlobalSearch from "./GlobalSearch";
import Store from "../../../Store";
import {
    getValidSearchVal,
    capitalizeFirstLetter,
    isConnStateEqualTo,
    getArchiveSetting
} from "../../../Helpers/Utility";
import {
    getUserInfoForSearch,
    getDataFromRoster,
    getDataFromSDK
} from "../../../Helpers/Chat/User";
import { isSingleChat } from "../../../Helpers/Chat/ChatHelper";
import {
    CONNECTION_STATE_CONNECTING,
    CONNECTION_STATE_CONN_FAILED,
    CONNECTION_STATE_ERROR_OCCURED
} from "../../../Helpers/Chat/Constant";
import PropTypes from "prop-types";
import { GLOBAL_SEARCH_ENABLED } from "../../processENV";

class RecentChatSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            searchEnable: false,
            searchValue: "",
            recentChatNames: [],
            recentChatItems: [],
            filteredContacts: [],
            prevMessageTime: "",
            searchPaginationCursor: null,
            prevSearchMessageTime: null,
            searchLoading: false,
        };
        this.timer = 0;
        this.searchApiTimer = 0;
        this.searchRequestId = 0;
        this.lastSearchedValue = "";
        this.chatExist = false;
    }

    filterUserNameFromRecent = (recentChatArray) => recentChatArray.map((chat) => chat.fromUserId);

    filterRosterByUserNames = (recentChatArray, rosterDataArray) => {
        const recentChatNames = this.filterUserNameFromRecent(recentChatArray);
        return rosterDataArray.filter((profile) => {
            const rosterJid = profile.username ? profile.username : profile.userId;
            return recentChatNames.indexOf(rosterJid) > -1;
        });
    };

    filterProfileFromRoster = (filteredRoaster, messageFrom) => {
        return getDataFromRoster(messageFrom);
    };

    filterProfileFromGroup = (messageFrom) => {
        const { groupsData: { data: groupsDataArray = [] } = {} } = this.props;
        return groupsDataArray?.find((groups) => messageFrom === groups.groupId);
    };

    filterProfileFromBroadcast = (messageFrom) => {
        const { broadCastData: { data: { broadcastList: broadcastListArray = [] } = {} } = {} } = this.props;
        return broadcastListArray.find((broadcast) => messageFrom === broadcast.jid);
    };

    getRoaster = (chatType = "groupchat", messageFrom = "") => {
        const messageType = {
            groupchat: this.filterProfileFromGroup,
            broadcast: this.filterProfileFromBroadcast
        };
        return messageType[chatType]?.(messageFrom);
    };

    constructRecentChatItems = (recentChatArray, filteredRoaster) => {
        let recent = [];
        sortBydate([...recentChatArray])
            .map(async (chat) => {
                let data = {};
                if (isSingleChat(chat.chatType)) {
                    data = this.filterProfileFromRoster(filteredRoaster, chat.fromUserId);
                } else {
                    data = this.getRoaster(chat.chatType, chat.fromUserId);
                }
                recent.push({
                    recent: chat,
                    roster: data || {}
                });
            })
        return recent.filter((eachmessage) => eachmessage);
    };

    componentWillUnmount() {
        clearTimeout(this.timer);
        clearTimeout(this.searchApiTimer);
        clearTimeout(this._loaderHideTimer);
    }

    getRecentChatsItems() {
        const {
            rosterData: { id: rosterId, data: rosterDataArray = [] } = {},
            recentChatData: { id: recentchatId, data: recentChatArray = [] } = {}
        } = this.props;
        const filteredRoaster = this.filterRosterByUserNames(recentChatArray, rosterDataArray);
        let recentChatItems = this.constructRecentChatItems(recentChatArray, filteredRoaster);
        let recentChatNames = this.filterUserNameFromRecent(recentChatArray);
        let unArchiveChats = recentChatArray.filter(obj => obj.archiveStatus === 0).length;
        let ArchiveChats = recentChatArray.filter(obj => obj.archiveStatus === 1).length;
        if (recentChatArray && recentChatArray.length > 0 && ArchiveChats > 10 && unArchiveChats < 15) {
            this.fetchMoreRecentChats(recentChatArray)
        }
        return { recentChatItems, recentChatNames, rosterId, recentchatId };
    }

    fetchMoreRecentChats = async (recentChatArray) => {
        if (!Array.isArray(recentChatArray) || recentChatArray.length === 0) return;
        const messageTime = Math.min(...recentChatArray.map(obj => obj.messageTime));
        if (this.state.prevMessageTime == messageTime) {
            return;
        }
        const recentChats = await SDK.getRecentChatsByPagination({ messageTime });
        Store.dispatch(RecentChatAction(recentChats.data));
        this.setState({
            prevMessageTime: messageTime
        });
    };

    componentDidMount() {
        this.initializeRecentChats();
    }

    scheduleLoaderHide = () => {
        if (!this.state.loader || this._loaderHideScheduled) return;
        this._loaderHideScheduled = true;
        this._loaderHideTimer = setTimeout(() => this.setState({ loader: false }), 2000);
    };

    initializeRecentChats = async () => {
        const { recentChatData: { id: recentchatId } = {} } = this.props;
        if (!recentchatId) return;
        await this.resolveRecentChatProfiles();
        const { recentChatItems, recentChatNames } = this.getRecentChatsItems();
        this.setState({
            recentChatItems,
            recentChatNames,
        });
        this.scheduleLoaderHide();
    };

    applyRecentChatUpdate = (refreshUnreadCount) => {
        const { recentChatItems, recentChatNames } = this.getRecentChatsItems();
        this.scheduleLoaderHide();
        this.setState((prevState) => ({
            recentChatItems,
            recentChatNames,
            refreshUnreadCount: prevState.searchValue ? false : refreshUnreadCount
        }), () => {
            const nextRecentChatNames = this.state.recentChatNames;
            const nextRecentChatItems = this.state.recentChatItems;
            this.props.updateRoster({ recentChatNames: nextRecentChatNames, recentChatItems: nextRecentChatItems });
            if (this.state.searchValue && !this.isGlobalSearchActive()) {
                this.applyLocalSearchFilter(this.state.searchValue, refreshUnreadCount);
            }
        });
    };

    resolveRecentChatProfiles = async () => {
        const {
            recentChatData: { data: recentChatArray = [] } = {},
            rosterData: { rosterNames } = {}
        } = this.props;
        if (!Array.isArray(recentChatArray) || recentChatArray.length === 0) return;
        const known = rosterNames instanceof Map ? rosterNames : new Map();
        const pending = [];
        recentChatArray.forEach((chat) => {
            if (!isSingleChat(chat.chatType)) return;
            const { fromUserId } = chat;
            if (fromUserId && !known.has(fromUserId)) {
                pending.push(getDataFromSDK(fromUserId));
            }
        });
        if (pending.length > 0) {
            await Promise.allSettled(pending);
        }
    };

    componentDidUpdate(prevProps) {
        const {
            rosterData: { id: rosterId } = {},
            recentChatData: { id: recentchatId, refreshUnreadCount } = {},
            commonData: {
                data: { isArchived = false }
            }
        } = this.props;

        const isRefreshed = isArchived !== prevProps?.commonData?.data?.isArchived;

        if ((prevProps.rosterData.id !== rosterId) || ((!prevProps.recentChatData.id && recentchatId) || (prevProps.recentChatData.id !== recentchatId)) || isRefreshed) {
            if (!recentchatId) return;
            const isFirstRecentChatBatch = !prevProps.recentChatData.id && recentchatId;
            if (isFirstRecentChatBatch) {
                this.resolveRecentChatProfiles().then(() => this.applyRecentChatUpdate(refreshUnreadCount));
                return;
            }
            if (prevProps.recentChatData.id !== recentchatId) {
                this.resolveRecentChatProfiles();
            }
            this.applyRecentChatUpdate(refreshUnreadCount);
            return;
        }

        if (
            prevProps?.broadCastData?.id &&
            this.props.broadCastData &&
            prevProps.broadCastData.id !== this.props.broadCastData.id &&
            this.props.broadCastData?.data?.broadcastList?.length !== prevProps.broadCastData?.data?.broadcastList?.length
        ) {
            const recentChatsRes = SDK.getRecentChatsByPagination();
            if (recentChatsRes && recentChatsRes.statusCode === 200) {
                Store.dispatch(RecentChatAction(recentChatsRes.data));
            }
            return;
        }

        if (prevProps.groupsData && this.props.groupsData && prevProps.groupsData.id !== this.props.groupsData.id) {
            this.updateGroupInfo();
        }
    }

    /**
     * handleGroupData() method to handle name and image of groups in realtime
     */
    updateGroupInfo = () => {
        let { recentChatItems } = this.state;

        if (recentChatItems.length === 0) return;
        const updateRecentChat = recentChatItems.map((chat) => {
            const { recent, roster } = chat;
            if (recent.chatType !== "groupchat") {
                return chat;
            }
            const groupId = roster.groupId || recent.fromUserId;
            const data = this.filterProfileFromGroup(groupId);
            return {
                recent: recent,
                roster: data || {}
            };
        });
        this.setState(
            {
                recentChatItems: updateRecentChat
            },
            () => {
                let recentChatNames = this.state.recentChatNames;
                recentChatItems = this.state.recentChatItems;
                this.props.updateRoster({ recentChatNames, recentChatItems });
            }
        );
    };

    recentChatSearchFilter = (searchWith) => {
        const { recentChatItems } = this.state;
        this.chatExist = false;
        return recentChatItems.map((item) => {
            const { roster } = item;
            const regexList = getUserInfoForSearch(roster);
            const updateSearch = regexList.find((str) => {
                if (!str) return false;
                return str.search(new RegExp(searchWith, "i")) !== -1;
            });
            if (updateSearch) {
                item.hidden = false;
                this.chatExist = true;
                return item;
            }
            item.hidden = true;
            return item;
        });
    };

    contactsSearch = (searchTerm) => {
        const { recentChatNames } = this.state;
        const {
            rosterData: { data }
        } = this.props;
        if (!data) return [];
        return data.filter((item) => {
            const rosterJid = item.username ? item.username : item.userId;
            if (recentChatNames.indexOf(rosterJid) > -1) {
                return false;
            }

            const regexList = getUserInfoForSearch(item);
            return regexList.find((str) => {
                if (!item.isFriend || !str) return false;
                return str.search(new RegExp(searchTerm, "i")) !== -1;
            });
        });
    };

    applyLocalSearchFilter = (searchValue, refreshUnreadCount) => {
        const searchWith = getValidSearchVal(searchValue);
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            const updatedList = this.recentChatSearchFilter(searchWith);
            const filteredContacts = this.contactsSearch(searchWith);
            this.setState({
                searchEnable: !!searchValue,
                searchValue: searchValue,
                filteredRecentChat: updatedList,
                filteredContacts: filteredContacts,
                refreshUnreadCount
            });
        }, 0);
    };

    fetchSearchedRecentChats = async (rawValue) => {
        const trimmed = (rawValue || "").trim();
        if (!trimmed) return;
        if (this.lastSearchedValue === trimmed) return;
        const reqId = ++this.searchRequestId;
        this.lastSearchedValue = trimmed;
        this.setState({ searchLoading: true });
        try {
            const res = await SDK.getRecentChatsByPagination({ name: trimmed });
            if (reqId !== this.searchRequestId) return;
            if (this.state.searchValue.trim() !== trimmed) return;
            if (res && res.statusCode === 200 && Array.isArray(res.data)) {
                if (res.data.length > 0) {
                    Store.dispatch(RecentChatAction(res.data));
                }
                const cursor = res.data.length > 0 ? Math.min(...res.data.map(o => o.messageTime)) : null;
                this.setState({ searchPaginationCursor: cursor, prevSearchMessageTime: null });
            }
        } finally {
            if (reqId === this.searchRequestId) {
                this.setState({ searchLoading: false });
            }
        }
    };

    reloadInitialRecentChats = async () => {
        const reqId = ++this.searchRequestId;
        const res = await SDK.getRecentChatsByPagination({ name: '' });
        if (reqId !== this.searchRequestId) return;
        if (this.state.searchValue && this.state.searchValue.trim()) return;
        if (res && res.statusCode === 200 && Array.isArray(res.data)) {
            Store.dispatch(resetRecentChat());
            Store.dispatch(RecentChatAction(res.data));
            this.setState({ prevMessageTime: '' });
        }
    };

    /**
     * Global search owns the whole search experience on the recent page, so the local
     * filtering and the name-based recent chat fetch are skipped while it is active.
     */
    isGlobalSearchActive = () => GLOBAL_SEARCH_ENABLED && this.props.pageType === "recent";

    searchFilterList = (searchValue, refreshUnreadCount) => {
        if (this.isGlobalSearchActive()) {
            this.setState({ searchValue, searchEnable: false });
            return;
        }
        this.applyLocalSearchFilter(searchValue, refreshUnreadCount);
        clearTimeout(this.searchApiTimer);
        if (!searchValue || !searchValue.trim()) {
            // Search cleared — invalidate any in-flight backend search and reload the original list
            this.searchRequestId++;
            this.lastSearchedValue = "";
            this.setState({ searchPaginationCursor: null, prevSearchMessageTime: null, searchLoading: false });
            this.reloadInitialRecentChats();
            return;
        }
        this.setState({ searchLoading: true });
        this.searchApiTimer = setTimeout(() => {
            this.fetchSearchedRecentChats(searchValue);
        }, 350);
    };

    shouldComponentUpdate(nextProps) {
        const { callUserJID, messageData: { id, data: { messageType } = {} } = {} } = this.props;
        if (callUserJID !== nextProps.callUserJID) {
            return true;
        }
        const nextPropsMsgId = nextProps?.messageData?.id;
        const nextPropsMsgType = nextProps?.messageData?.data?.messageType;
        const checkExist = isRenderMessageType(nextPropsMsgType);
        return !(messageType && nextPropsMsgId !== id && checkExist);
    }

    handleRecentChatsScroll = async (event) => {
        const { target } = event;
        const { scrollTop, clientHeight, scrollHeight } = target;
        if ((scrollTop + clientHeight + 1) < scrollHeight) return;

        const { searchValue, searchPaginationCursor, prevSearchMessageTime } = this.state;
        const trimmedSearch = (searchValue || "").trim();

        if (trimmedSearch) {
            if (!searchPaginationCursor) return;
            if (prevSearchMessageTime === searchPaginationCursor) return;
            const reqId = ++this.searchRequestId;
            const res = await SDK.getRecentChatsByPagination({ name: trimmedSearch, messageTime: searchPaginationCursor });
            if (reqId !== this.searchRequestId) return;
            if (this.state.searchValue.trim() !== trimmedSearch) return;
            if (res && res.statusCode === 200 && Array.isArray(res.data)) {
                if (res.data.length > 0) {
                    Store.dispatch(RecentChatAction(res.data));
                }
                const newCursor = res.data.length > 0 ? Math.min(...res.data.map(o => o.messageTime)) : searchPaginationCursor;
                this.setState({
                    searchPaginationCursor: newCursor,
                    prevSearchMessageTime: searchPaginationCursor
                });
            }
            return;
        }

        const { recentChatData: { data: recentChatArray = [] } = {} } = this.props;
        const messageTime = Array.isArray(recentChatArray) && recentChatArray.length > 0 ? Math.min(...recentChatArray.map(obj => obj.messageTime)) : null;
        if (this.state.prevMessageTime == messageTime) {
            return;
        }
        const recentChats = await SDK.getRecentChatsByPagination({ messageTime });
        Store.dispatch(RecentChatAction(recentChats.data));
        this.setState({
            prevMessageTime: messageTime
        });
    };


    render() {
        const { recentChatItems, filteredRecentChat, searchEnable, searchValue, filteredContacts, loader, searchLoading } = this.state;
        const {
            handleConversationSectionDisplay,
            callUserJID,
            handleShowCallScreen,
            callType,
            messageData,
            newChatStatus,
            callMode,
            pageType,
            unreadCountData: { unreadDataObj = {} } = {},
            featureStateData
        } = this.props;
        const { isRecentChatSearchEnabled = false } = featureStateData;
        const updatedRecentChat = searchEnable ? filteredRecentChat : recentChatItems;
        const showGlobalSearch = this.isGlobalSearchActive() && isRecentChatSearchEnabled && Boolean(searchValue);
        const loaderStyle = {
            width: 80,
            height: 80
        };
        let archivedChats = [],
            archiveUnreadCount = 0;
        updatedRecentChat.map((el) => {
            const { recent: { archiveStatus = 0, fromUserId = "", unreadCount = 0 } = {} } = el;
            if (archiveStatus === 1) {
                if (unreadDataObj[fromUserId]) {
                    unreadDataObj[fromUserId]?.count > 0 && (archiveUnreadCount += 1);
                } else {
                    unreadCount > 0 && (archiveUnreadCount += 1);
                }
                archivedChats.push(fromUserId);
            }
        });
        const isPermanentArchvie = getArchiveSetting();

        if (loader) {
            return (
                <div className="loader-container">
                    <img src={loaderSVG} alt="loader" style={loaderStyle} />
                </div>
            );
        }

        return (
            <div className="chat-list-container">
                {pageType === "recent" && isRecentChatSearchEnabled && <RecentSearch placeHolder={"Search or start a new chat"} search={this.searchFilterList} />}
                {(!this.props.isAppOnline ||
                    isConnStateEqualTo([
                        CONNECTION_STATE_CONNECTING,
                        CONNECTION_STATE_CONN_FAILED,
                        CONNECTION_STATE_ERROR_OCCURED
                    ])) && (
                        <div className="networkoffline">
                            <i className="icon">
                                <IconNoInternet />
                            </i>
                            <div>
                                <h4>Computer not connected</h4>
                                <p>Make sure your computer has an active internet connection.....</p>
                            </div>
                        </div>
                    )}
                {showGlobalSearch && (
                    <GlobalSearch
                        searchTerm={searchValue}
                        handleConversationSectionDisplay={handleConversationSectionDisplay}
                    />
                )}
                {!showGlobalSearch && (
                    <div
                        className={`chat-list ${!this.props.isAppOnline ||
                            isConnStateEqualTo([
                                CONNECTION_STATE_CONNECTING,
                                CONNECTION_STATE_CONN_FAILED,
                                CONNECTION_STATE_ERROR_OCCURED
                            ])
                            ? "offline"
                            : ""
                            } ${pageType === "archive" ? "archive" : ""} ${pageType === "archive" && updatedRecentChat.length === 0 && !searchValue ? " no-chat-archive " : ""
                            } ${(pageType != "archive") && updatedRecentChat.length === 0 && !searchValue ? " no-chat " : ""}`}
                        onScroll={e => this.handleRecentChatsScroll(e)}
                    >
                        <RecentChat
                            pageType={pageType}
                            searchTerm={searchValue}
                            handleConversationSectionDisplay={handleConversationSectionDisplay}
                            recentChatItems={updatedRecentChat}
                            callUserJID={callUserJID}
                            callStatus={this.props.callStatus}
                            handleShowCallScreen={handleShowCallScreen}
                            messageData={messageData}
                            callType={callType}
                            callMode={callMode}
                            recentChatExist={this.chatExist}
                            refreshUnreadCount={this.state.refreshUnreadCount}
                            handlePopupState={this.props.handlePopupState}
                            archiveLength={archivedChats.length}
                            vCardData={this.props.vCardData}
                        />

                        <RosterContacts searchTerm={searchValue} filteredContacts={filteredContacts} />

                        {searchValue && searchLoading && (
                            <div className="search-loader-container">
                                <img src={loaderSVG} alt="searching" className="search-loader" />
                            </div>
                        )}
                        {!this.chatExist && filteredContacts.length === 0 && searchValue && !searchLoading && (
                            <div
                                className={`no-search-record-found ${pageType === "recent" && archivedChats.length ? "has-archive" : ""
                                    }`}
                            >
                                <div className={`norecent-chat`}>
                                    <i className="norecent-chat-img">
                                        <EmptySearch />
                                    </i>
                                    <h4>{NO_RESULTS_FOUND}</h4>
                                </div>
                            </div>
                        )}
                        {((archivedChats.length === 0 && pageType === "archive") ||
                            (pageType === "recent" && updatedRecentChat.length - archivedChats.length === 0)) &&
                            !searchValue && (
                                <div
                                    className={`norecent-chat ${pageType === "recent" && archivedChats.length ? "has-archive" : ""}`}
                                >
                                    {pageType === "archive" ? (
                                        <Fragment>
                                            <i className="norecent-chat-img">
                                                <IconEmptyArchive />
                                            </i>
                                            <h4>{"No archived chats"}</h4>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <i className="norecent-chat-img">
                                                {" "}
                                                <StartVector />{" "}
                                            </i>
                                            <h4>{NO_RECENT_CHAT_INFO}</h4>
                                            <h4>
                                                {NO_RECENT_CLICK_ON_INFO}
                                                <i>
                                                    <Nochat />
                                                </i>{" "}
                                                {NO_RECENT_SEARCH_CONTACTS_INFO}
                                            </h4>
                                        </Fragment>
                                    )}
                                </div>
                            )}
                    </div>
                )}
                <Title />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        featureStateData: state.featureStateData,
        rosterData: state.rosterData,
        recentChatData: state.recentChatData,
        singleChatMsgHistoryData: state.singleChatMsgHistoryData,
        groupsData: state.groupsData,
        messageData: state.messageData,
        broadCastData: state.broadCastData,
        isAppOnline: state?.appOnlineStatus?.isOnline,
        connectionState: state.ConnectionStateData.data,
        isEnableArchived: state?.webLocalStorageSetting?.isEnableArchived,
        commonData: state?.commonData,
        unreadCountData: state.unreadCountData,
        vCardData: state.vCardData.data,
    };
};

const mapDispatchToProps = {
    updateRecentChat: RecentChatUpdateAction,
    updateNotification: RecentChatUpdateNotification,
    updateRoster: RecentChatRoster
};

export default connect(mapStateToProps, mapDispatchToProps)(RecentChatSection);

RecentChatSection.propTypes = {
    handleConversationSectionDisplay: PropTypes.func,
    callUserJID: PropTypes.string,
    handleShowCallScreen: PropTypes.func,
    callType: PropTypes.string,
    messageData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    newChatStatus: PropTypes.bool,
    callMode: PropTypes.string,
    pageType: PropTypes.string,
    unreadCountData: PropTypes.shape({
        unreadDataObj: PropTypes.shape({
            fromUserId: PropTypes.shape({
                count: PropTypes.number
            })
        })
    }),
    featureStateData: PropTypes.shape({
        isRecentChatSearchEnabled: PropTypes.bool
    }),
    groupsData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    broadCastData: PropTypes.object,
    rosterData: PropTypes.object,
    recentChatData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    commonData: PropTypes.object,
    updateRoster: PropTypes.func,
    isAppOnline: PropTypes.bool,
    handleArchivedChatList: PropTypes.func,
    callStatus: PropTypes.string,
    handlePopupState: PropTypes.func
};
